// Get values from environment variables
const API_BASE_URL = process.env.REACT_APP_API_URL;
const IMAGE_BASE_URL = process.env.REACT_APP_IMAGE_URL;

export const API_ENDPOINTS = {
  // Admin endpoints
  ADMIN_LOGIN: `${API_BASE_URL}/admin/login.php`,
  ADMIN_CHECK: `${API_BASE_URL}/admin/check_auth.php`,
  ADMIN_LOGOUT: `${API_BASE_URL}/admin/logout.php`,
  ADMIN_DASHBOARD: `${API_BASE_URL}/admin/get_dashboard.php`,
  ADMIN_SETTINGS: `${API_BASE_URL}/admin/update_settings.php`,
  ADMIN_SYNC_SHARE_META: `${API_BASE_URL}/admin/sync_share_meta.php`,
  ADMIN_EVENTS: `${API_BASE_URL}/admin/manage_event_days.php`,
  ADMIN_SCHEDULE: `${API_BASE_URL}/admin/manage_schedule.php`,
  ADMIN_GIFTS: `${API_BASE_URL}/admin/manage_gifts.php`,
  ADMIN_VENUE: `${API_BASE_URL}/admin/manage_venue.php`,
  ADMIN_GALLERY: `${API_BASE_URL}/admin/manage_gallery.php`,
  ADMIN_RSVP: `${API_BASE_URL}/admin/manage_rsvp.php`,
  ADMIN_RSVP_FIELDS: `${API_BASE_URL}/admin/manage_rsvp_fields.php`,
  ADMIN_ACCOMMODATION: `${API_BASE_URL}/admin/manage_accommodation.php`,
  UPLOAD_IMAGE: `${API_BASE_URL}/upload.php`,
  UPLOAD_FONT: `${API_BASE_URL}/upload_font.php`,
  GET_FONTS: `${API_BASE_URL}/get_fonts.php`,
  DELETE_FONT: `${API_BASE_URL}/delete_font.php`,
  
  // Public endpoints
  GET_SETTINGS: `${API_BASE_URL}/get_settings.php`,
  GET_EVENTS: `${API_BASE_URL}/get_event_days.php`,
  GET_VENUE: `${API_BASE_URL}/get_venue.php`,
  GET_GIFTS: `${API_BASE_URL}/get_gifts.php`,
  GET_GALLERY: `${API_BASE_URL}/get_gallery.php`,
  GET_AIRBNB: `${API_BASE_URL}/get_airbnb.php`,
  GET_RSVP_SETTINGS: `${API_BASE_URL}/get_rsvp_settings.php`,
  GET_RSVP_FORM: `${API_BASE_URL}/get_rsvp_form.php`,
  SUBMIT_RSVP: `${API_BASE_URL}/submit_rsvp.php`,
  RESERVE_GIFT: `${API_BASE_URL}/reserve_gift.php`,
  SUBMIT_PLEDGE: `${API_BASE_URL}/submit_pledge.php`,
  ADMIN_PLEDGES: `${API_BASE_URL}/admin/manage_pledges.php`,
  ADMIN_RUN_PLEDGE_REMINDERS: `${API_BASE_URL}/admin/run_pledge_reminders.php`,
};

export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  const base = String(IMAGE_BASE_URL || '').replace(/\/+$/, '');
  const p = String(path).trim();

  // Common cases we store in DB / UI:
  // - /wedding/backend/uploads/abc.jpg
  // - /backend/uploads/abc.jpg
  // - /uploads/abc.jpg
  // - abc.jpg
  // We want: <IMAGE_BASE_URL>/abc.jpg (and preserve subfolders under uploads if any).
  const normalized = p
    .replace(/^\/?wedding\/backend\/uploads\/?/i, '')
    .replace(/^\/?backend\/uploads\/?/i, '')
    .replace(/^\/?uploads\/?/i, '')
    .replace(/^\/+/, '');

  if (!base) return p;
  return `${base}/${normalized}`;
};

export default API_ENDPOINTS;